// Merca Custom file for move currencyConverter to sidebar in mobile

const MOBILE_QUERY = '(max-width: 767px)';

let originalParent = null;
let originalNextSibling = null;

function moveCurrencyConverterToDrawer() {
  const sideBarTarget = document.querySelector(
    'header-sidebar .header-sidebar__scroller'
  );
  const currencyConverter = document.querySelector('.bacurr-cur-blocker');

  if (!sideBarTarget || !currencyConverter) return false;

  // Save original position only once
  if (!originalParent) {
    originalParent = currencyConverter.parentNode;
    originalNextSibling = currencyConverter.nextSibling;
  }

  sideBarTarget.appendChild(currencyConverter);
  return true;
}

function restoreCurrencyConverter() {
  const currencyConverter = document.querySelector('.bacurr-cur-blocker');

  if (!currencyConverter || !originalParent) return;

  if (originalNextSibling) {
    originalParent.insertBefore(currencyConverter, originalNextSibling);
  } else {
    originalParent.appendChild(currencyConverter);
  }
}

function handleScreenChange(e) {
  if (e.matches) {
    // Mobile
    if (!moveCurrencyConverterToDrawer()) {
      const observer = new MutationObserver(() => {
        if (moveCurrencyConverterToDrawer()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  } else {
    // Desktop
    restoreCurrencyConverter();
  }
}

// Initial check
const mediaQuery = window.matchMedia(MOBILE_QUERY);
handleScreenChange(mediaQuery);

// Listen for resize changes
mediaQuery.addEventListener('change', handleScreenChange);
